import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import metadata from "./data/site.config.json";

import enTranslation from "./locales/en/translation.json";
import bnTranslation from "./locales/bn/translation.json";
import esTranslation from "./locales/es/translation.json";
import frTranslation from "./locales/fr/translation.json";
import hiTranslation from "./locales/hi/translation.json";
import neTranslation from "./locales/ne/translation.json";
import ptTranslation from "./locales/pt/translation.json";
import zhHansTranslation from "./locales/zh-Hans/translation.json";
import zhHantTranslation from "./locales/zh-Hant/translation.json";

const resources = {
  en: {
    translation: enTranslation,
  },
  bn: {
    translation: bnTranslation,
  },
  es: {
    translation: esTranslation,
  },
  fr: {
    translation: frTranslation,
  },
  hi: {
    translation: hiTranslation,
  },
  ne: {
    translation: neTranslation,
  },
  pt: {
    translation: ptTranslation,
  },
  zh_Hans: {
    translation: zhHansTranslation,
  },
  zh_Hant: {
    translation: zhHantTranslation,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    debug: process.env.NODE_ENV === "development",

    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
